import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@mui/material";
import UpdateServico from "./UpdateServico";
import GenericDataGrid from "Admin/components/AdminComponents/GenericDataGrid";

function ListServicos() {
  const [pointer, setPointer] = useState(null);
  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(false);

  const handleOpen = (id) => {
    setPointer(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setReload(!reload); // Toggle reload state to trigger useEffect
  };

  const fields = [
    { name: 'codigo', label: 'Código' },
    { name: 'nome', label: 'Nome' },
    { 
      name: 'preco_venda', 
      label: 'Valor',
      render: (item) => `R$ ${item.preco_venda}`
    },
    { 
      name: 'status', 
      label: 'Status',
      render: (item) => item.status === 0 ? 'Inativo' : 'Ativo'
    }
  ];

  const actions = [
    { label: 'Editar', handler: (item) => handleOpen(item.id) }
  ];

  useEffect(() => {
    // This effect will run when the reload state changes
  }, [reload]);

  return (
    <>
      <GenericDataGrid
        title="Listagem de Serviços"
        endpoint="/servicos"
        fields={fields}
        actions={actions}
        filters={['codigo', 'nome', 'status']}
        reload={reload} // Pass reload state to trigger data reload
      />
      <Dialog 
        open={open && pointer} 
        onClose={handleClose} 
        PaperProps={{
          style: {
            width: '70vw',
            height: '80vh',
            maxWidth: 'none', 
            maxHeight: 'none',
          }
        }}
      >
        <DialogContent>
          <UpdateServico pointer={pointer} />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ListServicos;